/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Contact_Codes_Create_CodeInputs */

const en_forms_contact_codes_create_code = /** @type {(inputs: Forms_Contact_Codes_Create_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const de_forms_contact_codes_create_code = /** @type {(inputs: Forms_Contact_Codes_Create_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Forms_Contact_Codes_Create_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_contact_codes_create_code = /** @type {((inputs?: Forms_Contact_Codes_Create_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Contact_Codes_Create_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_contact_codes_create_code(inputs)
	return de_forms_contact_codes_create_code(inputs)
});